<template>
	<div class="team-list bg-blue3">
		<div class="top layout-row">
			<div class="title color-black-gray1 layout-row layout-hv-center">小組清單</div>
			<div class="open-progress button-tp color-white bg-blue1" @click="toggleAllProcess" v-if="!processOpen">查看各組進度</div>
			<div class="open-progress button-tp color-white bg-black-gray2" @click="toggleAllProcess" v-if="processOpen">收合進度</div>
		</div>
		<div class="table">
			<el-table :data="storyList.list" style="width: 100%" max-height="500" header-row-class-name="header-row" :row-class-name="dataRowClass" ref="storyList">
				<el-table-column type="expand">
					<template slot-scope="{row}">
						<ProcessDetail :progress="row.progress"></ProcessDetail>
					</template>
				</el-table-column>
				<el-table-column label="故事帳號" prop="account" />
				<el-table-column label="故事名稱" prop="story_name" />
				<el-table-column label="小組名稱" prop="team_name" />
				<el-table-column label="進度" prop="progress.message" />
				<el-table-column label="操作">
					<template slot-scope="{row}">
						<div class="row" gutter="20" align-y="center">
							<el-button v-if="row.apply_status >= 4" @click="editStory(row)" type="text">檢視</el-button>
							<div v-else @click="editStory(row)" class="edit-button button-tp color-white bg-green1">編輯</div>
							<div class="delete-button button-tp color-white bg-danger" @click="deletePersonStory(row)">
								<font-awesome-icon icon="trash-alt" />
							</div>
						</div>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="pagination">
			<el-pagination @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize" layout="prev, pager, next, jumper" :total="storyList.total" />
		</div>
		<!-- <div class="more-team-button button-tp color-white bg-blue1">
			<font-awesome-icon class="plus-circle" icon="plus-circle" />&nbsp;挑戰平台系統更新中，新增故事功能暫停
		</div> -->
		<router-link :to="{name: 'set_up_under18'}" class="more-team-button button-tp color-white bg-blue1">
		<!-- <div class="more-team-button button-tp color-white bg-blue1" @click="$emit('createTeam')"> -->
			<font-awesome-icon class="plus-circle" icon="plus-circle" />&nbsp;再新增一個小組
		</router-link>
	</div>
</template>

<script>
import ProcessDetail from "@/components/challenge/signUp/ProcessDetail";
import { mapState, mapActions } from "vuex";

export default {
	data() {
		return {
			currentPage: 1,
			pageSize: 10,
			processOpen: false
		};
	},
	computed: {
		...mapState("story", ["storyList"]),
		query() {
			return {
				page: this.currentPage,
				size: this.pageSize
			}
		}
	},
	watch: {
		async $route(val) {
			console.log(this.query);
			await this.getPersonStoryList(this.query);
		}
	},
	methods: {
		...mapActions("story", ["deleteStory", "getPersonStoryList"]),
		dataRowClass({ row, rowIndex }) {
			if (rowIndex % 2 == 1) {
				return "even-row";
			} else {
				return "odd-row";
			}
		},
		toggleAllProcess() {
			this.processOpen = !this.processOpen;
			for (let row of this.storyList.list) {
				this.$refs.storyList.toggleRowExpansion(row, this.processOpen);
			}
		},
		async handleCurrentChange(page) {
			this.currentPage = page;
			this.$router.replace({ query: this.query });
			this.processOpen = false;
		},
		getProgressInfo(progress) {
			return progress[0];
		},
		editStory(story) {
			this.$router.push({
				name: "editStory",
				params: { id: story.id },
				query: { is18: story.is_18 }
			});
		},
		deletePersonStory(storyData) {
			this.$confirm(
				`確定刪除「${storyData.team_name}（組名)」這則故事？`,
				"提示",
				{
					confirmButtonText: "確定",
					cancelButtonText: "取消",
					type: "warning"
				}
			).then(async () => {
				try {
					await this.deleteStory(storyData.id);
					await this.getPersonStoryList({
						page: this.currentPage,
						size: this.pageSize
					});
					this.$message.success("刪除成功");
				} catch (e) {
					this.$message.error(e);
				}
			}).catch(() => { });
		}
	},
	created() {
		let query = this.$route.query;
		this.currentPage = Number(query.page) || 1;
		this.pageSize = Number(query.size) || 10;
	},
	mounted() { },
	components: {
		ProcessDetail
	}
};
</script>

<style lang="scss">
.team-list {
	padding: 18px;

	.top {
		justify-content: space-between;
		margin-bottom: 10px;

		.title {
			font-size: 18px;
			font-weight: 500;
		}

		.open-progress {
			padding: 6px 21px;
			border-radius: 5px;
		}
	}

	.table {
		.header-row {
			background-color: #f7fbfe;
		}
		.el-table th {
			background-color: #f7fbfe;
		}

		.even-row {
			background-color: #f2f9ff;
		}

		.odd-row {
			background-color: #f7fbfe;
		}

		.el-table__expanded-cell {
			background-color: #f7fbfe;
			padding: 20px;
		}
	}

	.delete-button {
		width: 49px;
		height: 26px;
		margin-top: 6px;
		margin-bottom: 6px;
	}

	.edit-button {
		width: 88px;
		height: 26px;
		margin-right: 12px;
	}

	.more-team-button {
		margin-top: 60px;
		padding: 21px 0;
		font-size: 16px;
		font-weight: 500;
		// cursor: not-allowed;
		// background: #c8c9cc;
	}

	.pagination {
		margin-top: 30px;

		.el-pagination {
			display: flex;
			justify-content: center;
		}
	}
}
</style>